import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, Directive } from '@angular/core';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {StateEnum} from '../../common/services';

/**
 * Classe mère des components avis
 */
@Directive()
export class AvisHelper implements OnChanges {
  @Input() avis: boolean = null;
  @Input() commentaire: string = null;

  _isInRole = false;
  @Input()
  set isInRole(value) {
    this._isInRole = value;
  }

  get isInRole() {
    return this._isInRole;
  }

  @Output() avisUpdated = new EventEmitter<any>();
  @Output() commentaireUpdated =  new EventEmitter<any>();
  @Output() winpayeUpdated = new EventEmitter<any>();

  avisObj = [{value: true, label: 'Oui'}, {value: false, label: 'Non'}];

  avisFormGroup: UntypedFormGroup;

  /**
   * L'avis / commentaire concerne qui ?
   * MS | SBTCP | DRH
   * Doit être fixé sur le component qui dérive
   */
  avisConcerned: StateEnum = null;

  constructor(public formBuilder: UntypedFormBuilder) {
    this.avisFormGroup = this.createAvisFormGroup(formBuilder);

  }
  getCommentaire(): string {
    return this.avisFormGroup?.get('commentaire')?.value || '';
  }
  createAvisFormGroup(formBuilder) {
    return this.avisFormGroup = this.formBuilder.group({
      avis: [''],
      commentaire: [''],
      winpaye: ['', Validators.required]
    });
  }
  initAvisFormGroup() {
    if (! this.avisConcerned) {
      throw Error('avisConcerned non fixé !');
    }

    this.avisFormGroup = this.formBuilder.group({
      avis: [''],
      commentaire: [''],
      winpaye: ['', Validators.required]
    });

    this.avisFormGroup.controls['avis'].valueChanges.subscribe((value) => {
      const emitData = { role: this.avisConcerned, value: value };
      this.avisUpdated.emit(emitData);
    });

    this.avisFormGroup.controls['commentaire'].valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((com) => {
        const emitData = { role: this.avisConcerned, value: com };
        this.commentaireUpdated.emit(emitData);
      });
  }

  findAvis(value) {
    return this.avisObj.find((k) => k.value === value);
  }

  setAvis(changes: SimpleChanges) {
    const avis = this.findAvis(changes.avis.currentValue);
    if (avis) {
      this.avisFormGroup.patchValue({avis: avis.value});
    }
  }

  setCommentaire(changes: SimpleChanges) {
    this.avisFormGroup.patchValue({commentaire: changes.commentaire.currentValue});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isInRole && changes.isInRole.isFirstChange() && changes.isInRole.currentValue !== null) {
      if (! changes.isInRole.currentValue) {
        setTimeout(() => this.avisFormGroup.disable(), 100);
      }
    }

    if (changes.avis && changes.avis.isFirstChange() && changes.avis.currentValue !== null) {
      this.setAvis(changes);
    }

    if (changes.commentaire && changes.commentaire.isFirstChange() && changes.commentaire.currentValue !== null) {
      this.setCommentaire(changes);
    }
  }
}
